import { synchronizationConstant } from 'actionTypes/synchronization.constant';
import _ from 'lodash';
import { Reducer } from 'redux';
import { SynchronizationActionType } from 'types/actions/synchronization';
import { SynchronizationState } from 'types/reducers/synchronization';

const initialState: SynchronizationState = {
  connections: {
    list: [],
    select_options: [],
  },
  projects: {
    list: [],
  },
  documents: {
    list: [],
  },
  current: {
    connection_id: '',
    site_url: '',
    selected_folders: [],
    folder_name: '',
    folder_path: '',
  },
  isLoading: false,
  isError: false,
  errorCode: '',
  errorMessage: '',
};

const synchronizationReducer: Reducer<SynchronizationState, SynchronizationActionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case synchronizationConstant.CONNECTIONS_FETCH_SUCCEEDED:
      const selectionOptions = action.payload?.length
        ? action.payload.map((connection) => {
            return {
              label: connection.display_name,
              value: connection.id,
            };
          })
        : [];
      return {
        ...state,
        connections: {
          ...state.connections,
          list: [...action.payload],
          select_options: [...selectionOptions],
        },
      };

    case synchronizationConstant.PROJECTS_FETCH_SUCCEEDED:
      return {
        ...state,
        projects: {
          list: [...action.payload],
        },
        isLoading: false,
      };

    case synchronizationConstant.PROJECTS_FETCH_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case synchronizationConstant.DOCUMENT_FETCH_SUCCEEDED:
      return {
        ...state,
        documents: {
          list: [...action.payload],
        },
        current: {
          ...state.current,
          selected_folders: [],
        },
        isLoading: false,
      };

    case synchronizationConstant.DOCUMENT_FETCH_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case synchronizationConstant.UPDATE_CURRENT_CONNECTION:
      return {
        ...state,
        current: {
          ...state.current,
          connection_id: action.payload,
        },
      };

    case synchronizationConstant.UPDATE_CURRENT_PROJECT:
      return {
        ...state,
        current: {
          ...state.current,
          site_url: action.payload,
        },
      };

    case synchronizationConstant.UPDATE_CURRENT_FOLDER:
      return {
        ...state,
        current: {
          ...state.current,
          folder_path: action.payload.folder_path,
          folder_name: action.payload.folder_name,
        },
      };

    case synchronizationConstant.UPDATE_CURRENT_SELECTED_FOLDERS:
      let selectedFolders = state.current.selected_folders;
      if (action.payload?.path) {
        const existedDocument = state.current.selected_folders.find(
          (e) => e.path === action.payload.path
        );
        if (existedDocument) {
          selectedFolders = state.current.selected_folders.filter(
            (e) => e.path !== action.payload.path
          );
        } else {
          selectedFolders = [...state.current.selected_folders, action.payload];
        }
      }

      return {
        ...state,
        current: {
          ...state.current,
          selected_folders: [...selectedFolders],
        },
      };

    case synchronizationConstant.UPDATE_SYNC_DOCUMENT_STATUS:
      if (!_.isArray(action.payload.result) || !action.payload.result.length)
        return {
          ...state,
          isError: true,
        };
      return {
        ...state,
        current: {
          connection_id: '',
          site_url: '',
          selected_folders: [],
          folder_name: '',
          folder_path: '',
        },
        isError: false,
      };

    case synchronizationConstant.SYNC_DOCUMENT_PROCESSING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case synchronizationConstant.RESET_PROJECT:
      return {
        ...state,
        documents: {
          list: [],
        },
        current: {
          ...state.current,
          site_url: '',
          selected_folders: [],
          folder_name: '',
          folder_path: '',
        },
      };
    case synchronizationConstant.RESET_SYNC_PROJECT:
      return {
        ...state,
        connections: {
          list: [],
          select_options: [],
        },
        projects: {
          list: [],
        },
      };

    default:
      return state;
  }
};

export default synchronizationReducer;
